import http from '../utils/http'

// 用户列表
export function listAPI(data) {
    return http.post('/member/list', data)
}

//用户详情
export function detailAPI(data) {
    return http.get('/member/detail', data)
}
// 编辑用户
export function editMemberAPI(data, params) {
    return http.post('/member/edit', data, params)
}
// 禁言用户
export function forbiddenwordsAPI(data) {
    return http.post('/member/forbiddenwords', data)
}
// 禁号用户
export function forbiddenmembersAPI(data) {
    return http.post('/member/forbiddenmembers', data)
}